import React from 'react';
import { MDCTextInput } from '../../../library/components/mdc-components';

export default class GallerySearchBar extends React.Component {
    constructor(props) {
        super(props);
        var initialValue = props.initialValue || '';
        this.state = {
            value: initialValue,
            showCancel: initialValue.length > 0
        };
    }

    onCancel=() => {
        this.textbox.value="";
        this.textbox.blur();
        this.setState({ expanded: false });
    }

    onChange=(e) => {
        let value=e.target.value;
        this.setState({ value:value, showCancel: value.length > 0 });
    }

    onKeyEnter=(e) => {
        if (e.key === 'Enter') {
            let value=this.state.value;
            this.props.onSubmitSearch(value);
            // Tracking — fires only on Enter (not per keystroke). Skip
            // empty values since Enter-on-empty is the "clear search"
            // path, not a search. Listener in /js/tracking/gallery.js
            // fires the Plunk engagement.
            try {
                var trimmed = (value || '').trim();
                if (trimmed) {
                    document.dispatchEvent(new CustomEvent('gallery-find-submitted', {
                        detail: { value: trimmed }
                    }));
                }
            } catch (ev) { }
        }
    }
    
    onCancel=(e) => {
        this.setState({ value:'', showCancel:false },()=>{
            this.props.onSubmitSearch('');
        }); 
    }

    render() {
        let iconCls='search-icon-g';
        let cls ='gallery-search-input-inner';
        let cancelCls='gallery-search-cancel';
        if(this.state.showCancel){
            cancelCls+=' visible';
        }
        if(this.state.expanded){
            cls+=' expanded';
            iconCls+=' hide';   
        }
        let value=this.state.value;
        return (
            <div className="gallery-search-bar">
                
                <div className="gallery-search-input">
                    <div className={cls}>
                        <img src="/images/icons/search-icon.png" className="search-icon-g-2"></img>
                        <div className="gallery-search-input-field no-box-shadow-focus">
                            <MDCTextInput
                                placeholder="Find"
                                ref={(ref) => this.textbox = ref}
                                value={value}
                                onChange={this.onChange}
                                onKeyEnter={this.onKeyEnter}

                            />
                        </div>
                        <span className={cancelCls} onClick={this.onCancel}>x</span>    
                    </div>
                </div>
             
            </div>
        );
    }
}
